export const CALENDAR_SETTINGS_PATH = '/app/availability/calendar_settings'

export const CALENDAR_CONNECTIONS_POPUP_ROUTE = {
  rootPath: `${CALENDAR_SETTINGS_PATH}/calendar_connections`,
  newPath: `${CALENDAR_SETTINGS_PATH}/calendar_connections/new`,
  getPullAccountPath: (accountId) => `${CALENDAR_SETTINGS_PATH}/calendar_connections/pull/${accountId}`,
  newExchangePath: `${CALENDAR_SETTINGS_PATH}/calendar_connections/exchange/new`,
  getNewExchangePath: (accountId) => `${CALENDAR_SETTINGS_PATH}/calendar_connections/exchange/new?calendar_account_id=${accountId}`,
  getIcloudPath: (accountId) => `/app/availability/connected_calendars/icloud/new?calendar_account_id=${accountId}`,
  getOutlookDesktopEditPath: (accountId) => (
    `/app/availability/connected_calendars/outlook_desktop/${accountId}/edit`
  ),
}
